import React from 'react';
import Typed from 'react-typed';
import Typical from 'react-typical'
// import Particles from 'react-particles-js';
// import particlesConfig from './particlesConfig';
import image2 from '../backpweb.jpg';
import image3 from '../jb.jpeg';

const Header = () => {
    return (
        <div className="header">
 
            <div className="main">
          
<h2> I am:</h2>
<Typical className="type-style-text"
        steps={[ 'Software Engineer', 1000,'Researcher', 1000,'Mentor', 1000,'Sports Programmer', 1000,'Developer', 1000]}
        loop={Infinity}
      />
       
     
            </div>
        </div>
    )
}

export default Header
